<template>
  <div class="modal" v-if="show">
    <div class="modal-background"></div>
    <div
      class="modal-dialog-centered"
      :class="{
        'modal-dialog w-100': size === 'md',
        'modal-dialog-lg': size === 'lg',
      }"
    >
      <div v-if="$slots.noWrapper" class="position-relative">
        <slot name="noWrapper"></slot>
      </div>
      <div class="modal-content" :style="contentStyle" v-else>
        <header
          class="modal-header d-flex align-items-center justify-content-between col-gap-2"
          v-if="$slots.header"
        >
          <slot name="header"></slot>
          <img
            src="../assets/images/Vector (1).png"
            @click="$emit('close')"
            alt=""
            class="cursor-pointer"
          />
        </header>
        <section class="modal-body" v-if="$slots.body">
          <slot name="body"></slot>
        </section>
        <footer class="modal-footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    size: {
      type: String,
      default: "md",
    },
    contentStyle: {
      type: String,
    },
  },
  name: "ModalContainer",
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
}

.modal-background {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

/* .modal-content {
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  display: flex;
  flex-direction: column;
  max-height: 90%;
  max-width: 90%;
  overflow: auto;
  padding: 1rem;
} */

.modal-header,
.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  border-bottom: unset;
}

.modal-body {
  flex: 1;
  overflow: auto;
  padding: 1rem;
}

.modal-dialog-lg {
  width: 1000px;
}

@media (max-width: 1010px) {
  .modal-dialog-lg {
    width: calc(100% - 20px);
  }
}
</style>
